import React, { useEffect, useRef } from "react";
import { Table, Warning } from "@culturehq/components";
import Sortable from "sortablejs";
import { deepClone, Trans } from "app/utils";
import BuilderTemplateRow from "./BuilderTemplateRow";
import { useTemplateBuilder } from "./context/TemplateBuilderContext";
import styles from "./buildertemplates.module.scss";

const BuilderTemplateList = () => {
  const tableBodyRef = useRef<HTMLTableSectionElement>(null);
  const { state: { templates }, handleSort } = useTemplateBuilder();
  const sortableRef = useRef<Sortable | null>(null);


  useEffect(() => {
    if (tableBodyRef.current) {
      if (sortableRef.current) {
        sortableRef.current.destroy();
        sortableRef.current = null;
      }

      const updatedTemplates = deepClone(templates);

      sortableRef.current = Sortable.create(tableBodyRef.current, {
        animation: 150,
        handle: ".sortable__drag-handler",
        onEnd: evt => {
          if (!evt || evt.oldIndex === undefined || evt.newIndex === undefined) return;

          const { oldIndex, newIndex } = evt;
          const [movedItem] = updatedTemplates.splice(oldIndex, 1);
          if (!movedItem) return;

          updatedTemplates.splice(newIndex, 0, movedItem);
          handleSort(updatedTemplates);
        }
      });
    }

    return () => {
      if (sortableRef.current) {
        sortableRef.current.destroy();
        sortableRef.current = null;
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templates]);

  if (!templates.length) {
    return (
      <div className={styles["builder-template__table__wm"]}>
        <Warning><Trans>No results to show.</Trans></Warning>
      </div>
    );
  }

  return (
    <Table className={styles["builder-template__table"]}>
      <thead className={styles["builder-template__table__header"]}>
        <tr>
          <th />
          <th>Template</th>
          <th>Type</th>
          <th>Created</th>
          <th>Status</th>
          <th># Times Used</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody ref={tableBodyRef}>
        {templates.map(template => (
          <BuilderTemplateRow
            key={template.id}
            template={template}
          />
        ))}
      </tbody>
    </Table>
  );
};

export default BuilderTemplateList;
